import styled from "styled-components";

// Сначала объявляем RadioContent
export const RadioContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RadioText = styled.span`
  //padding-top: 5px;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

// Радио кнопка должна быть видимой для :has селектора
export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 0;
  padding: 0;

  // Делаем радио видимым, но очень маленьким
  .ant-radio {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;

    // Стили для фокуса
    &:focus + ${RadioContent} {
      outline: 2px solid #1890ff;
      outline-offset: 2px;
    }
  }
`;

// Затем объявляем остальные компоненты
export const FilterBlock = styled.div`
  min-height: 48px;
  box-sizing: border-box;
  margin: 0;

  font-size: 14px;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  background-color: rgba(0, 0, 0, 0.02);
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 3px 16px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.5714285714285714;
  cursor: pointer;
  transition: all 0.3s, visibility 0s;

  flex: 1 1 0;
  min-width: 0;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  // Стиль для выбранного элемента
  &:has(.ant-radio.ant-radio-checked) {
    border: 2px solid #0a2240;
    //background-color: #0a2240;
    //color: #fff;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;

  .ant-radio-group {
    display: flex;
    width: 100%;
    gap: inherit;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;

    .ant-radio-group {
      flex-direction: column;
    }

    ${FilterBlock} {
      flex: 1 1 auto;
      border-radius: 8px;
      border: 1px solid #d9d9d9;
      margin: 0;

      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;